export default __webpack_public_path__ + "static/media/(21).ee64647f.jpeg";